import { NullableComparer } from 'lib/NullableComparer';
import { ItineraryPoint as ServerItineraryPoint } from 'server/models/ItineraryPoint';
import { ScheduleDateType } from './ScheduleDateType';

export { ItineraryPointOptions, ItineraryPointData } from 'server/models/ItineraryPoint';

export class ItineraryPoint extends ServerItineraryPoint {
    // TS port of the PortCallExtensions static class in PortCall.Models\PortCall\PortCall.cs.
    static readonly EffectiveOrder = (pt1 : ItineraryPoint, pt2 : ItineraryPoint) =>
        pt1.Arrival.Effective() < pt2.Arrival.Effective() ? -1
        : pt1.Arrival.Effective() > pt2.Arrival.Effective() ? 1
        : pt1.Departure.Effective() < pt2.Departure.Effective() ? -1
        : pt1.Departure.Effective() > pt2.Departure.Effective() ? 1
        : pt1.Id() < pt2.Id() ? -1
        : pt1.Id() > pt2.Id() ? 1
        : 0;

    static readonly EstimatedOrder = (pt1 : ItineraryPoint, pt2 : ItineraryPoint) =>
        pt1.Arrival.Estimated() < pt2.Arrival.Estimated() ? -1
        : pt1.Arrival.Estimated() > pt2.Arrival.Estimated() ? 1
        : pt1.Departure.Estimated() < pt2.Departure.Estimated() ? -1
        : pt1.Departure.Estimated() > pt2.Departure.Estimated() ? 1
        : pt1.Id() < pt2.Id() ? -1
        : pt1.Id() > pt2.Id() ? 1
        : 0;

    static readonly ActualOrder = (pt1 : ItineraryPoint, pt2 : ItineraryPoint) => {
        const arrivalCompare = NullableComparer(pt1.Arrival.Actual(), pt2.Arrival.Actual());
        if (arrivalCompare !== 0) return arrivalCompare;
        const departureCompare = NullableComparer(pt1.Departure.Actual(), pt2.Departure.Actual());
        if (departureCompare !== 0) return departureCompare;
        return pt1.Id() < pt2.Id() ? -1 : pt1.Id() > pt2.Id() ? 1 : 0;
    };

    ArrivalEntity() {
        return this.Schedule().find(d => d.Type() === ScheduleDateType.IPArrival) || null;
    }

    DepartureEntity() {
        return this.Schedule().find(d => d.Type() === ScheduleDateType.IPDeparture) || null;
    }

    IsMovementPoint() {        
        return this.IsPortArrival() || this.IsPortDeparture() || (this.BerthReservation() !== null && this.BerthReservation()!.CancelledDate() === null);
    }

    NextMovementPoint() {
        const pc = this.PortCall(),
            series = pc && pc.MovementSeries(),
            pos = series && series.indexOf(this);
        return pos === null || pos === -1 || pos === series!.length - 1 ? null : series![pos + 1];
    }

    PreviousMovementPoint() {
        const pc = this.PortCall(),
            series = pc && pc.MovementSeries(),
            pos = series && series.indexOf(this);
        return pos === null || pos === -1 || pos === 0 ? null : series![pos - 1];
    }
}


// WEBPACK FOOTER //
// ./data/models/ItineraryPoint.ts